import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from '../shared/services/api.service';
import { CommonService } from '../shared/services/common.service';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatModule } from '../appModules/mat.module';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ExportService } from '../shared/services/exportservice';

@Component({
  selector: 'app-result-master',
  imports: [CommonModule, ReactiveFormsModule, MatModule, MatPaginatorModule],
  templateUrl: './result-master.component.html',
  styleUrl: './result-master.component.scss'
})
export class ResultMasterComponent {
  formGroup!: FormGroup;
  isEdit = false;
  isResultList = true;
  isLoading = false;

  dataSource: any[] = [];
  displayedColumns = {
    cols: ['sno', 'result_name', 'min_percentage', 'max_percentage', 'description'],
    label: ['S.No', 'Result Name', 'Min %', 'Max %', 'Description']
  };

  pagination = {
    page: 1,
    limit: 10,
    length: 0
  };

  currentPage = 0;
  selectedId: string | null = null;

  constructor(
    private fb: FormBuilder,
    public api: ApiService,
    public common: CommonService
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.getResultList();
  }

  initForm() {
    this.formGroup = this.fb.group({
      result_name: ['', Validators.required],
      min_percentage: ['', Validators.required],
      max_percentage: ['', Validators.required],
      description: ['']
    });
  }

  addResult() {
    this.formGroup.reset();
    this.isResultList = false;
    this.isEdit = false;
    this.selectedId = null;
  }

  back() {
    this.isResultList = true;
    this.formGroup.reset();
  }

  resetForm() {
    this.formGroup.reset();
    this.isEdit = false;
    this.selectedId = null;
  }

  saveResult() {
    if (this.formGroup.invalid) return;

    this.isLoading = true;
    const formData = this.formGroup.value;

    // If edit, include id
    if (this.isEdit && this.selectedId) {
      formData.id = this.selectedId;
    }

    this.api.post('settings/resultmaster/add', formData, true).subscribe({
      next: (response) => {
        this.common.notification(response.message);
        this.isLoading = false;
        if (response.status) {
          this.getResultList();
          this.resetForm();
          this.isResultList = true;
        }
      },
      error: (error) => {
        this.common.notification(`Error saving result: ${error.message || 'Unknown error'}`, true);
        this.isLoading = false;
      }
    });
  }

  getResultList() {
    const query = {
      page: this.pagination.page,
      limit: this.pagination.limit
    };

    this.api.post('settings/resultmaster/list', query).subscribe({
      next: (res) => {
        if (res.status) {
          this.dataSource = res.data.rows || [];
          this.pagination.length = res.data.count || 0;
          this.currentPage = (this.pagination.page - 1) * this.pagination.limit;
        }
      },
      error: (err) => {
        this.common.notification('Error fetching result list', true);
      }
    });
  }

  downloadResultList() {
    //this.api.download('settings/downloadResultMasters', {}, 'result-masters-list.xlsx');
  }

  edit(row: any) {
    this.formGroup.patchValue(row);
    this.selectedId = row.id;
    this.isEdit = true;
    this.isResultList = false;
  }

  delete(row: any) {
    if (confirm('Are you sure you want to delete this record?')) {
      this.api.post('settings/resultmaster/remove', { id: row.id }, true).subscribe({
        next: (res) => {
          this.common.notification(res.message);
          if (res.status) this.getResultList();
        },
        error: (err) => {
          this.common.notification('Delete failed', true);
        }
      });
    }
  }

  pageEvent(event: any) {
    this.pagination.page = event.pageIndex + 1;
    this.pagination.limit = event.pageSize;
    this.getResultList();
  }
}
